module.exports = __webpack_public_path__ + "static/media/drinkIcon.5457b0b9.svg";